import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WeeklyHot from './components/WeeklyHot';
import AnnualRecap from './components/AnnualRecap';
import Moments from './components/Moments';
import Features from './components/Features';
import Faq from './components/Faq';
import About from './components/About';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';
import BackTop from './components/BackTop';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <WeeklyHot />
        <AnnualRecap />
        <Moments />
        <Features />
        <Faq />
        <About />
        <Newsletter />
      </main>
      <Footer />
      <BackTop />
    </>
  );
}